import React, {useEffect, useRef, useState} from 'react';
import cl from "./FormImage.module.css";
import {Avatar, Button} from "@mui/material";
import ImageCropDialog from "../components/ImageCropDialog/ImageCropDialog";
import FormControlCaption from "./FormControlCaption";

const FormImage = ({
                         label,
                         initImageUrl,
                         imageViewSize,
                         imageCanvasMaxSize,
                         controlRef,
                         tipText,
                         readOnly,
                     }) => {

    const [photoUrl, setPhotoUrl] = useState(initImageUrl);
    const [cropDialogOpen, setCropDialogOpen] = useState(false);
    const [imageDataUrl, setImageDataUrl] = useState("");

    const fileInputRef = useRef(null);

    const correctedImageViewSize = imageViewSize === undefined ? 100 : imageViewSize;
    const correctedImageCanvasMaxSize = imageCanvasMaxSize === undefined ? correctedImageViewSize : imageCanvasMaxSize;

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                isChangedToImage: () => photoUrl.startsWith("data:"),
                isChangedToCleared: () => initImageUrl && !photoUrl,
                getBase64: () => photoUrl.split("base64,")[1],
            };
        }
    })

    function handleAddOrReplace() {
        fileInputRef.current.click();
    }

    const handleFileInputChange = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            const reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = function (e) {
                handleImageSelected(reader.result);
            }
        }
    }

    const handleImageSelected = (imgDataUrl) => {
        setImageDataUrl(imgDataUrl);
        setCropDialogOpen(true);
    };

    const handleCropComplete = (croppedArea) => {
        const canvas = document.createElement("canvas");
        canvas.width = Math.min(correctedImageCanvasMaxSize, croppedArea.width);
        canvas.height = Math.min(correctedImageCanvasMaxSize, croppedArea.height);
        const ctx = canvas.getContext("2d");
        ctx.imageSmoothingEnabled = croppedArea.width > canvas.width || croppedArea.height > canvas.height;
        ctx.imageSmoothingQuality = "high";
        const img = new Image();

        img.src = imageDataUrl;
        img.onload = () => {
            ctx.drawImage(
                img,
                croppedArea.x,
                croppedArea.y,
                croppedArea.width,
                croppedArea.height,
                0,
                0,
                canvas.width,
                canvas.height
            );

            const dataURL = canvas.toDataURL('image/png');
            setPhotoUrl(dataURL);
        };
    };

    return (
        <div className={cl.main}>
            <FormControlCaption
                text={label}
                tipText={tipText}
            />
            <Avatar
                variant="square"
                sx={{width: correctedImageViewSize, height: correctedImageViewSize}}
                src={photoUrl ? photoUrl : undefined}
            >
                {photoUrl ?
                    <p align={"center"}>{photoUrl}</p> :
                    <p align={"center"}>Не задано</p>}
            </Avatar>
            {!readOnly && <div className={cl.buttonsArea}>
                {!photoUrl && <FooterButton
                    label="Добавить ..."
                    onClick={handleAddOrReplace}
                />}
                {photoUrl && <FooterButton
                    label="Заменить ..."
                    onClick={handleAddOrReplace}
                />}
                {initImageUrl && photoUrl !== initImageUrl && <FooterButton
                    label="Вернуть исходное"
                    onClick={() => setPhotoUrl(initImageUrl)}
                />}
                {photoUrl && <FooterButton
                    label="Удалить"
                    sx={{borderColor: "gray", color: "#844"}}
                    onClick={() => setPhotoUrl("")}
                />}
                <input
                    ref={fileInputRef}
                    className={cl.fileInput}
                    type="file"
                    accept="image/*"
                    onChange={handleFileInputChange}
                />
            </div>}
            {cropDialogOpen && <ImageCropDialog
                open={true}
                image={imageDataUrl}
                message={"message"}
                onDone={(confirmed, croppedArea) => {
                    setCropDialogOpen(false);
                    if (confirmed)
                        handleCropComplete(croppedArea);
                }}
            />}
        </div>
    );
};

const FooterButton = ({label, onClick, sx}) => {
    return <Button variant="outlined" size="small" onClick={onClick} sx={sx}>{label}</Button>
}

export default FormImage;